import { PropertyTiles } from './../../components/properties/property-tiles';
import LoadingAnimation from "../loading/loading";

import './../../pages/properties/property.css';
import { arrayAny } from '../../utils/arrayUtils';

export const LandlordPropertiesTab = ({ landlord, properties }) => {

    const tabName = "Properties";

    return landlord && landlord.displayName
        && (
            <>
                <h3 className="mt-10px">{tabName} of {landlord.displayName}</h3>
                <div key={tabName}>
                    <div className={'pos-customer bg-gray-100'} >
                        <div className="pos-content">
                            {!!!properties && <LoadingAnimation />}
                            {arrayAny(properties) &&
                                <div className="pos-content-container" options={{ suppressScrollX: true }}>
                                    <div className="product-row">
                                        <PropertyTiles properties={properties} />
                                    </div>
                                </div>}
                        </div>
                    </div>
                </div>
            </>
        );
};